import InputComponent from "../../components/elements/InputComponent";
import TextareaComponent from "../../components/elements/TextareaComponent";
import ButtonComponent from "../../components/elements/ButtonComponent";
import InputPlusButton from "../../components/elements/InputPlusButton";
import { IFormDataU } from "./UserStepper";
import { motion } from "framer-motion";
import { CustomAxiosRequestConfig, axiosPrivate } from "../../api/axios";
import ControlledSelectElement from "../../components/elements/ControlledSelectElement";
import customZ from "../../utils/setZodCustomMessages";
import { zodResolver } from "@hookform/resolvers/zod";
import { childVariants } from "../../animation/RoutesAnimations";
import {
  notEmptyField,
  postalCodeSchema,
  fullTelNumberSchema,
} from "../../utils/customSchemas";
import { useForm, SubmitHandler } from "react-hook-form";
import { useState, useEffect } from "react";
import z from "zod";
import Lottie from "react-lottie";
import animationData from "../../../src/jsons/LoadingBg.json";
import {
  USER_FILL_JOB_INFO,
  USER_GET_JOB_INFO,
  USER_UPDATE_JOB_INFO,
} from "../../api/apiClient";

const step3Schema = customZ.object({
  job_industry: notEmptyField,
  rank: notEmptyField,
  job_title: notEmptyField,
  monthly_income: notEmptyField,
  workplace_name: notEmptyField,
  insurance_number: z.string().optional(),
  workplace_phone_number: fullTelNumberSchema,
  workplace_postal_code: postalCodeSchema,
  workplace_address: notEmptyField,
});
export interface monthlyIncomeType {
  monthly_income: string;
  name: string;
}

export interface rankType {
  rank: string;
  name: string;
}

export interface jobIndustryType {
  job_industry: string;
  name: string;
}

const monthlyIncomeList: monthlyIncomeType[] = [
  {
    monthly_income: "از ۷ میلیون تا ۱۰ میلیون",
    name: "از ۷ میلیون تا ۱۰ میلیون",
  },
  {
    monthly_income: "از ۱۰ میلیون تا ۱۵ میلیون",
    name: "از ۱۰ میلیون تا ۱۵ میلیون",
  },
  {
    monthly_income: "از ۱۵ میلیون تا ۲۰ میلیون",
    name: "از ۱۵ میلیون تا ۲۰ میلیون",
  },
  {
    monthly_income: "از ۲۰ میلیون تا ۲۷ میلیون",
    name: "از ۲۰ میلیون تا ۲۷ میلیون",
  },
  {
    monthly_income: "از ۲۷ میلیون به بالا",
    name: "از ۲۷ میلیون به بالا",
  },
];
const rankList: rankType[] = [
  {
    rank: "کارگر",
    name: "کارگر",
  },
  {
    rank: "کارمند",
    name: "کارمند",
  },
  {
    rank: "کارشناس",
    name: "کارشناس",
  },
  {
    rank: "سرپرست",
    name: "سرپرست",
  },
  {
    rank: "مدیر میانی",
    name: "مدیر میانی",
  },
  {
    rank: "مدیر ارشد",
    name: "مدیر ارشد",
  },
];

const jobIndustryList: jobIndustryType[] = [
  {
    job_industry: "خصوصی",
    name: "خصوصی",
  },
  {
    job_industry: "دولتی",
    name: "دولتی",
  },
  {
    job_industry: "صنفی",
    name: "صنفی",
  },
  {
    job_industry: "فاقد شغل",
    name: "فاقد شغل",
  },
];

function UserFormStep3({ formNo, setFormNo }: any) {
  const {
    handleSubmit,
    control,
    setValue,
    getValues,
    watch,
    formState: { errors },
  } = useForm<IFormDataU>({
    resolver: (data, context, options) => {
      return zodResolver(step3Schema)(data, context, options);
    },
  });

  const access_token = localStorage.getItem("access_token");
  const [jobInfo, setJobInfo] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [filledItems, setFilledItems] = useState<any>(false);
  const [isLoadingContents, setIsLoadingContents] = useState<boolean>(false);
  const [receivedValue, setReceivedValue] = useState("");
  const [canEdit, setCanEdit] = useState<boolean>(false);
  const [checkForUpdate, setCheckForUpdate] = useState<boolean>(false);

  const handleValueReceived = (value: any) => {
    setReceivedValue(value);
  };

  useEffect(() => {
    if (receivedValue) {
      setValue("workplace_address", receivedValue);
    }
  }, [receivedValue]);

  const updateFormValue: SubmitHandler<IFormDataU> = async (
    data: IFormDataU
  ) => {
    try {
      const response = await axiosPrivate.put(USER_UPDATE_JOB_INFO, data, {
        headers: {
          // prettier-ignore
          "accept": "application/json",
          // prettier-ignore
          "Authorization": `Bearer ${access_token}`,
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      });

      if (response?.status >= 200 && response?.status < 300) {
        setFormNo(formNo + 1);
        setIsLoading(false);
      } else {
        console.error(
          "ERROR in acceptRules:",
          response.data || response.statusText
        );
      }
    } catch (error) {
      setIsLoading(false);
      console.error("An unexpected error occurred:", error);
    }
  };

  const getJobInfo = async () => {
    setIsLoadingContents(true);
    setIsLoading(true);
    try {
      const response = await axiosPrivate.get(
        USER_GET_JOB_INFO,

        {
          headers: {
            // prettier-ignore
            "accept": "application/json",
            // prettier-ignore
            "Authorization": `Bearer ${access_token}`,
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
        }
      );
      setJobInfo(response.data.data);
      if (response?.status >= 200 && response?.status < 300) {
        setCheckForUpdate(true);
        setIsLoadingContents(false);

        setIsLoading(false);
        setFilledItems(true);
      } else {
        setIsLoadingContents(false);
      }
    } catch (error) {
      setIsLoadingContents(false);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getJobInfo();
  }, []);

  const onSubmit: SubmitHandler<IFormDataU> = async (data: IFormDataU) => {
    if (!jobInfo || jobInfo.length === 0) {
      setIsLoading(true);
      const formattedData = {
        ...data,
      };

      try {
        const response = await axiosPrivate.post(
          USER_FILL_JOB_INFO,
          formattedData,
          {
            headers: {
              // prettier-ignore
              "accept": "application/json",
              // prettier-ignore
              "Authorization": `Bearer ${access_token}`,
              "Content-Type": "multipart/form-data",
            },
            withCredentials: true,
          }
        );
        setFormNo(formNo + 1);

        if (response?.status >= 200 && response?.status < 401) {
          setIsLoading(false);
        } else {
          console.error(
            "ERROR in acceptRules:",
            response.data || response.statusText
          );
        }
      } catch (error) {
        setIsLoading(false);
        console.error("An unexpected error occurred:", error);
      }
    }
    if (jobInfo && !canEdit) {
      setFormNo(formNo + 1);
    }
    if (jobInfo && canEdit) {
      updateFormValue(data);
    }
  };

  useEffect(() => {
    setValue("job_industry", jobInfo?.job_industry);
    setValue("rank", jobInfo?.rank);
    setValue("job_title", jobInfo?.job_title);
    setValue("monthly_income", jobInfo?.monthly_income);
    setValue("workplace_name", jobInfo?.workplace_name);
    setValue("insurance_number", jobInfo?.insurance_number ?? "");
    setValue("workplace_phone_number", jobInfo?.workplace_phone_number);
    setValue("workplace_postal_code", jobInfo?.workplace_postal_code);
    setValue("workplace_address", jobInfo?.workplace_address);
  }, [setValue, jobInfo]);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    renderer: "svg",
  };

  const watchedjob_industry = watch("job_industry");
  const watchedrank = watch("rank");
  const watchedjob_title = watch("job_title");
  const watchedmonthly_income = watch("monthly_income");
  const watchedWorkplaceName = watch("workplace_name");
  const watchedInsuranceNumber = watch("insurance_number");
  const watchedworkplace_phone_number = watch("workplace_phone_number");
  const watchedworkplace_postal_code = watch("workplace_postal_code");
  const watchedworkplace_address = watch("workplace_address");

  useEffect(() => {
    if (
      watchedjob_industry !== jobInfo?.job_industry ||
      watchedrank !== jobInfo?.rank ||
      watchedjob_title !== jobInfo?.job_title ||
      watchedmonthly_income !== jobInfo?.monthly_income ||
      watchedWorkplaceName !== jobInfo?.workplace_name ||
      watchedworkplace_phone_number !== jobInfo?.workplace_phone_number ||
      watchedworkplace_postal_code !== jobInfo?.workplace_postal_code ||
      watchedworkplace_address !== jobInfo?.workplace_address ||
      watchedInsuranceNumber !== jobInfo?.insurance_number
    ) {
      setCanEdit(true);
    } else {
      setCanEdit(false);
    }
  }, [
    checkForUpdate,
    watchedjob_industry,
    watchedrank,
    watchedjob_title,
    watchedmonthly_income,
    watchedWorkplaceName,
    watchedInsuranceNumber,
    watchedworkplace_phone_number,
    watchedworkplace_postal_code,
    watchedworkplace_address,
    jobInfo,
  ]);

  if (isLoadingContents) {
    return (
      <>
        <div className="flex  gap-8 basis-3/4 rounded-md md:ml-8 ml-2 shadow-md">
          <div className=" full-screen">
            <Lottie options={defaultOptions} height={100} width={100} />
          </div>
        </div>
      </>
    );
  }
  return (
    <>
      <motion.form
        variants={childVariants}
        initial="initial"
        animate="final"
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col flex-1 gap-12 rounded-md shadow-md item-center justify-center"
      >
        <div className="w-full flex max-sm:flex-col sm:flex-col lg:flex-row flex-1 gap-12 rounded-md shadow-md mt-10 ">
          <div className=" flex flex-col max-sm:w-full sm:w-full lg:w-1/2  ">
            <div className="flex justify-between">
              <div className=" flex w-[49%]">
                <ControlledSelectElement
                  getValue={getValues}
                  // disabled={jobInfo}
                  APIgetValue={jobInfo?.job_industry}
                  label=" بخش شغلی"
                  options={jobIndustryList}
                  isRequired
                  getOptionLabel={(item) => item?.name}
                  control={control}
                  name="job_industry"
                  errors={errors?.job_industry}
                  showNonOption
                  defaultSelectValue="انتخاب کنید"
                  // setValue={setValue}
                  mode="multiSelect"
                />
              </div>
              <div className=" flex w-[49%]">
                <ControlledSelectElement
                  getValue={getValues}
                  // disabled={jobInfo}
                  APIgetValue={jobInfo?.rank}
                  label="رتبه"
                  options={rankList}
                  isRequired
                  getOptionLabel={(item) => item?.name}
                  control={control}
                  name="rank"
                  errors={errors?.rank}
                  showNonOption
                  defaultSelectValue="انتخاب کنید"
                  // setValue={setValue}
                  mode="multiSelect"
                />
              </div>
            </div>
            <InputComponent
              defaultValue={jobInfo?.job_title}
              size="regular"
              isRequired
              label="عنوان شغلی"
              name="job_title"
              control={control}
              errors={errors?.job_title}
              svgIcon={
                <svg
                  className="w-4 h-4 "
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 18"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M7 8a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm-2 3h4a4 4 0 0 1 4 4v2H1v-2a4 4 0 0 1 4-4Z"
                  />
                </svg>
              }
            />
            <InputComponent
              defaultValue={jobInfo?.workplace_name}
              size="regular"
              isRequired
              label=" نام محل کار"
              name="workplace_name"
              control={control}
              errors={errors?.workplace_name}
              svgIcon={
                <svg
                  className="w-4 h-4 "
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 18"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M7 8a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm-2 3h4a4 4 0 0 1 4 4v2H1v-2a4 4 0 0 1 4-4Z"
                  />
                </svg>
              }
            />

            <div>
              <ControlledSelectElement
                getValue={getValues}
                APIgetValue={jobInfo?.monthly_income}
                // disabled={jobInfo}
                label="درآمد ماهیانه"
                options={monthlyIncomeList}
                isRequired
                update
                getOptionLabel={(item: any) => item?.name}
                control={control}
                name="monthly_income"
                errors={errors?.monthly_income}
                showNonOption
                defaultSelectValue="درآمد خود را انتخاب کنید"
                // setValue={setValue}
                mode="multiSelect"
              />
            </div>
            <InputComponent
              defaultValue={jobInfo?.insurance_number}
              size="regular"
              type="tel"
              label=" شماره بیمه"
              name="insurance_number"
              control={control}
              maxLength={15}
              errors={errors?.insurance_number}
              svgIcon={
                <img
                  src="/icons/profile-card-outline.svg"
                  alt="phone icon"
                  width={16}
                />
              }
            />
          </div>
          <div className="flex flex-col max-sm:w-full sm:w-full lg:w-1/2">
            <InputComponent
              defaultValue={jobInfo?.workplace_phone_number}
              size="regular"
              isRequired
              type="tel"
              label=" شماره تماس محل کار"
              name="workplace_phone_number"
              control={control}
              errors={errors?.workplace_phone_number}
              svgIcon={
                <img
                  src="/icons/phone-outline.svg"
                  alt="phone icon"
                  width={16}
                />
              }
              maxLength={11}
            />
            <div className="">
              <div className="">
                <label className=" text-gray-900 text-Body-OneLine/14/Regular">
                  کد پستی محل کار
                </label>
                <span className="text-red-500 mr-[4px]">*</span>
              </div>
              <div className="">
                <InputPlusButton
                  // APIgetValue={jobInfo?.workplace_postal_code}
                  onValueReceived={handleValueReceived}
                  APIgetValue={jobInfo?.workplace_postal_code}
                  editable={true}
                  type="tel"
                  name="workplace_postal_code"
                  btnText="استعلام"
                  // btnDisabled={true}
                  inputIcon={
                    <img
                      src="/icons/mail-box-outline.svg"
                      alt="phone icon"
                      width={16}
                    />
                  }
                  control={control}
                  errors={errors?.workplace_postal_code}
                  maxLength={10}
                  direction="ltr"
                />
              </div>
            </div>
            <TextareaComponent
              APIgetValue={receivedValue ? receivedValue : ""}
              latestReceivedValue={receivedValue}
              editable={true}
              onChange={(value) => handleValueReceived(value)}
              dynamicRows={3}
              value={
                receivedValue
                  ? receivedValue
                  : jobInfo?.workplace_address
                  ? jobInfo?.workplace_address
                  : undefined
              }
              control={control}
              label="آدرس محل کار"
              helperText="در صورت صحیح نبودن آدرس استعلام شده، آدرس را ویرایش نمایید."
              name="workplace_address"
              errors={errors?.workplace_address}
              isRequired
            />
          </div>
        </div>
        <div className="flex w-full justify-center gap-1 pb-4 sticky bottom-0 bg-white right-0 left-0">
          <ButtonComponent
            className="mt-1 w-[120px] h-10"
            variant="outlined"
            onClick={() => setFormNo(formNo - 1)}
          >
            بازگشت
          </ButtonComponent>
          <ButtonComponent
            isClicked={isLoading}
            disabled={isLoading}
            type="submit"
            className="mt-1 w-[120px] h-10 mr-[8px]"
            variant="filled"
          >
            ادامه
          </ButtonComponent>
        </div>
      </motion.form>
    </>
  );
}
export default UserFormStep3;
